"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sk: {
    notFoundPage: {
      message: 'Položka alebo stránka sa nenašla, prípadne na jej zobrazenie nemáte oprávnenie.'
    },
    loginPage: {
      title: 'Prihlásenie k Sprinx CRM',
      username: 'Užívateľské meno',
      password: 'Heslo',
      loginButton: 'Prihlásiť'
    },
    loginErrorPage: {
      title: 'Prihlásenie sa nepodarilo',
      error: 'Prihlásenie sa nepodarilo. Užívateľské meno alebo heslo nenájdené.',
      pleaseRelogin: 'Zdá sa, že nie ste prihlásený. Prosím prihláste sa znovu.'
    },
    oauthLogin: {
      message: 'Musíte sa prihlásiť. Prosím zvoľte jedného z uvedených poskytovateľov.',
      loginButton: 'Prihlásiť sa pomocou účtu Sprinx',
      redirecting: 'Čakám na presmerovanie na autentizačný server...'
    },
    logout: {
      inProgress: 'Prebieha odhlásenie...',
      error: 'Chyba odhlásenia',
      gotoHome: 'Presmerovať na východziu stránku',
      success: 'Odhlásenie prebehlo úspešne.'
    }
  }
};
var _default = messages;
exports.default = _default;